import { render, staticRenderFns } from "./IntroFiltered.vue?vue&type=template&id=01923106&scoped=true&"
import script from "./IntroFiltered.vue?vue&type=script&lang=js&"
export * from "./IntroFiltered.vue?vue&type=script&lang=js&"
import style0 from "./IntroFiltered.vue?vue&type=style&index=0&id=01923106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01923106",
  null
  
)

export default component.exports